import { Outlet } from "react-router-dom";
import { useTranslations } from "@/hooks/use-translations";

export function AuthLayout() {
  const t = useTranslations("common");

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-bg-canvas">
      <div className="mb-8 flex items-center gap-2"></div>
      <div className="w-full max-w-md">
        <Outlet />
      </div>
    </div>
  );
}
